import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { useListDetailsContext } from 'modules/segmentation/contexts/listDetails';
import { SegmentationViewHeader } from './SegmentationViewHeader';
import { ListViewHeader } from './ListViewHeader';
import { PAGE_VARIATIONS } from '../../constants';

const PageHeaderContainer = styled.div`
  margin: 0 ${spacing.layoutLRPadding};
`;

export const PageHeader = () => {
  const { pageVariation } = useListDetailsContext();
  const isSegmentationView = pageVariation === PAGE_VARIATIONS.SEGMENTATION;
  return (
    <PageHeaderContainer>
      {isSegmentationView ? <SegmentationViewHeader /> : <ListViewHeader />}
    </PageHeaderContainer>
  );
};
